(() => {
  const INTERVAL = 4200; // ms
  const init = () => {
    const root = document.querySelector('.template-index .slideshow');
    if (!root) return;

    const drawer = document.querySelector('header-drawer');
    const isMenuOpen = () => drawer && (drawer.hasAttribute('open') || drawer.classList.contains('menu-opening'));

    const nextBtn = document.querySelector('.template-index .slideshow__controls .slider-button--next');
    if (!nextBtn) return;

    setInterval(() => {
      if (isMenuOpen()) return;
      nextBtn.click();
    }, INTERVAL);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
